import {
  verifyAXRuntime,
} from './AXRuntimeVerificationEngine';

export interface AXCommandCenterFeed {
  readonly status: 'healthy' | 'warning';
  readonly verified: boolean;
  readonly routesVerified: number;
  readonly navigationRulesVerified: number;
  readonly pageIdentitiesVerified: number;
  readonly generatedAt: string;
}

export function getAXCommandCenterFeed():
AXCommandCenterFeed {

  const runtime = verifyAXRuntime();

  return Object.freeze({
    status:
      runtime.passed
        ? 'healthy'
        : 'warning',
    verified: runtime.passed,
    routesVerified: runtime.routesVerified,
    navigationRulesVerified:
      runtime.navigationRulesVerified,
    pageIdentitiesVerified:
      runtime.pageIdentitiesVerified,
    generatedAt: runtime.verifiedAt,
  });
}
